import React from 'react'

export function Icon(props){
    const {size, ...res} = props
    return(
        <img {...res} width={size}/>
    )
}
